var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chatroom-container bg-light h-100 d-flex flex-column",
      class: { "fullscreen-mode": _vm.fullscreen }
    },
    [
      _c(
        "div",
        {
          staticClass: "py-1 px-4 d-flex w-100 align-items-center",
          staticStyle: { "border-bottom": "1px solid #ccc" }
        },
        [
          _c(
            "h4",
            { staticClass: "bold flex-grow-1 d-flex align-items-center" },
            [
              _c("span", [_vm._v("Mes conversations")]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm.selectedChatroom == null
                ? _c("span", [_vm._v("Choisir une conversation")])
                : _c("span", { staticClass: "flex-grow-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedChatroom.chatroom_name,
                          expression: "selectedChatroom.chatroom_name"
                        }
                      ],
                      staticClass: "form-control-title w-100",
                      attrs: {
                        type: "text",
                        placeholder: _vm.chatroomPlaceholderTitle(
                          _vm.selectedChatroom
                        )
                      },
                      domProps: { value: _vm.selectedChatroom.chatroom_name },
                      on: {
                        change: _vm.saveTitleChange,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.selectedChatroom,
                            "chatroom_name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
            ]
          ),
          _vm._v(" "),
          _vm.selectedChatroom != null &&
          (_vm.options.canInviteInOtherChatrooms ||
            _vm.selectedChatroom.chatroom_creation_user_id == _vm.user.user_id)
            ? _c("div", { staticClass: "ml-4" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "javascript:;",
                      title: "Inviter des utilisateurs"
                    },
                    on: { click: _vm.popupInviteUser }
                  },
                  [_c("i", { staticClass: "icon-user-follow" })]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedChatroom != null
            ? _c("div", { staticClass: "ml-4" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "javascript:;",
                      title: "Quitter la conversation"
                    },
                    on: {
                      click: function($event) {
                        return _vm.popupConfirmLeave(_vm.selectedChatroom)
                      }
                    }
                  },
                  [_c("i", { staticClass: "icon-logout" })]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedChatroom != null &&
          _vm.selectedChatroom.chatroom_creation_user_id == _vm.user.user_id
            ? _c("div", { staticClass: "ml-4" }, [
                _c(
                  "a",
                  {
                    staticClass: "font-red",
                    attrs: {
                      href: "javascript:;",
                      title: "Supprimer la conversation"
                    },
                    on: {
                      click: function($event) {
                        return _vm.popupConfirmDelete(_vm.selectedChatroom)
                      }
                    }
                  },
                  [_c("i", { staticClass: "icon-trash" })]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "ml-4" }, [
            _vm.fullscreen
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: "javascript:;",
                      title: "Quitter le mode plein-écran"
                    },
                    on: {
                      click: function($event) {
                        _vm.fullscreen = false
                      }
                    }
                  },
                  [_c("i", { staticClass: "icon-size-actual" })]
                )
              : _c(
                  "a",
                  {
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        _vm.fullscreen = true
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "icon-size-fullscreen",
                      attrs: { title: "Mode plein-écran" }
                    })
                  ]
                )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "chatroom-panels" }, [
        _c("div", { staticClass: "chatroom-left-panel" }, [
          _c(
            "div",
            {
              staticClass: "px-4 py-2",
              staticStyle: { "border-bottom": "1px solid #ccc" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filters.query,
                    expression: "filters.query"
                  }
                ],
                staticClass: "form-control input-sm",
                attrs: {
                  type: "text",
                  placeholder: "Rechercher des conversations..."
                },
                domProps: { value: _vm.filters.query },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.filters, "query", $event.target.value)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm.options.canCreateChatrooms
            ? _c(
                "div",
                {
                  staticClass: "px-4 py-2",
                  staticStyle: { "border-bottom": "1px solid #ccc" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm blue w-100",
                      on: { click: _vm.prepareAddingForm }
                    },
                    [
                      _vm._v("Démarrer une conversation "),
                      _c("i", { staticClass: "fa fa-plus" })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "chatroom-list-wrapper" }, [
            _vm.invitedChatrooms.length > 0
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticClass: "py-2 text-center",
                        staticStyle: { "border-bottom": "1px solid #ccc" }
                      },
                      [
                        _vm._v(
                          "\n            Invitations aux conversations\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.invitedChatrooms, function(chatroom, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "chatroom-list-item is-unread",
                          class: {
                            selected:
                              _vm.selectedChatroom != null &&
                              _vm.selectedChatroom.chatroom_id ==
                                chatroom.chatroom_id
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectChatroom(chatroom, true)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "py-2 pl-4" }, [
                            chatroom.participants.length == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "chatroom-item-icon",
                                    style: {
                                      "background-color":
                                        chatroom.participants[0]
                                          .user_background_color
                                    }
                                  },
                                  [_vm._v(_vm._s(chatroom.user_initials))]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-100 py-2" }, [
                            chatroom.chatroom_name == ""
                              ? _c(
                                  "div",
                                  { staticClass: "chatroom-item-title px-4" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.chatroomPlaceholderTitle(chatroom)
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "chatroom-item-title px-4" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(chatroom.chatroom_name) +
                                        "\n              "
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "chatroom-item-last-message px-4"
                              },
                              [_vm._v("Attente de réponse...")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "read-indicator" })
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.chatroomFilteredList.length > 0
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticClass: "py-2 text-center",
                        staticStyle: { "border-bottom": "1px solid #ccc" }
                      },
                      [
                        _vm._v(
                          "\n            Conversations actives\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.chatroomFilteredList, function(chatroom, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "chatroom-list-item",
                          class: {
                            "is-unread": chatroom.chatroom_unread,
                            selected:
                              _vm.selectedChatroom != null &&
                              _vm.selectedChatroom.chatroom_id ==
                                chatroom.chatroom_id
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectChatroom(chatroom, false)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "py-2 pl-4" }, [
                            chatroom.participants.length == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "chatroom-item-icon",
                                    style: {
                                      "background-color":
                                        chatroom.participants[0]
                                          .user_background_color
                                    }
                                  },
                                  [_vm._v(_vm._s(chatroom.user_initials))]
                                )
                              : chatroom.participants.length == 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "chatroom-item-icon",
                                    style: {
                                      "background-color": _vm.otherParticipant(
                                        chatroom
                                      ).user_background_color
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.otherParticipant(chatroom)
                                          .user_initials
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "chatroom-item-icon" },
                                  [_c("i", { staticClass: "fa fa-users" })]
                                )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-100 py-2" }, [
                            chatroom.chatroom_name == ""
                              ? _c(
                                  "div",
                                  { staticClass: "chatroom-item-title px-4" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.chatroomPlaceholderTitle(chatroom)
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "chatroom-item-title px-4" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(chatroom.chatroom_name) +
                                        "\n              "
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "chatroom-item-last-message px-4"
                              },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      chatroom.chatroom_last_message_user_name
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.advancedFormat(
                                        chatroom.chatroom_last_message_content
                                      )
                                    )
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "read-indicator" })
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chatroom-right-panel" },
          [
            _vm.selectedChatroom != null
              ? _c("chatroom-feed", {
                  ref: "chatroom-feed",
                  attrs: {
                    chatroom: _vm.selectedChatroom,
                    user: _vm.user,
                    isInvite: _vm.chatroomIsInvite
                  },
                  on: {
                    inviteAccepted: _vm.inviteAccepted,
                    inviteRejected: _vm.inviteRejected,
                    messageReceived: _vm.messageReceived
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.selectedChatroom != null
        ? _c("chatroom-invite-form", {
            ref: "chatroom-invite-form",
            attrs: { chatroom: _vm.selectedChatroom },
            on: { confirm: _vm.inviteUser }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("chatroom-add-form", {
        ref: "chatroom-add-form",
        attrs: { form: _vm.addingForm },
        on: { confirm: _vm.confirmAddingForm }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "mx-2" }, [
      _c("i", { staticClass: "fa fa-caret-right" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }